/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Vs_TitleInputs */

const en_wc_vs_title = /** @type {(inputs: Wc_Vs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WordCraft vs Microsoft Word`)
};

/**
* | output |
* | --- |
* | "WordCraft vs Microsoft Word" |
*
* @param {Wc_Vs_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_vs_title = /** @type {((inputs?: Wc_Vs_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Vs_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_vs_title(inputs)
});
export { wc_vs_title as "wc.vs.title" }